const contact = {
    title: '지원 받기',
    description: '도움 요청 또는 제품 피드백을 위해서, 아래의 방법을 통해 저희에게 문의해주세요.',
    discord: {
        title: '디스코드 커뮤니티 가입하기',
        description: '다른 개발자들과 솔루션을 찾기 위해 연결하세요.',
        button: '가입하기',
    },
    github: {
        title: 'GitHub 에서 소통하기',
        description: '이슈를 작성하고 GitHub에 제출하세요.',
        button: '열기',
    },
    email: {
        title: '이메일로 지원팀과 연락하기',
        description: '더 많은 정보나 도움을 위해 이메일을 보내주세요.',
        button: '보내기',
    },
    reserve: {
        title: 'Logto 팀과의 시간을 예약하세요',
        description: '빠르게 대화를 위해 세션 예약',
        button: '예약하기',
    },
};
export default Object.freeze(contact);
